export default {
  'open-menu': 'Ouvrir le menu',
  'close-menu': 'Fermer',
  'editorial-staff': 'Rédaction',
  about: 'Nous découvrir',
  shopLink: 'Un monde de possibilités',
}
